import { ArrowUpRight } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "~/components/ui/dialog"
import { Button } from "~/components/ui/button"
import { usePine59Welcome } from "~/hooks/use-pine59-welcome"

// Mirrors the Insights "Introducing Pine59" rebrand modal (una-insights
// PR #2149): hero graphic with the light logo, centered tagline + copy,
// full-width learn-more link and a single continue action.
export default function Pine59WelcomeDialog() {
  const { open, dismiss } = usePine59Welcome()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) dismiss()
      }}
    >
      <DialogContent className="max-w-md gap-0 overflow-hidden border-0 p-0 [&>button]:text-white [&>button]:opacity-90">
        <div
          className="flex h-56 items-center justify-center bg-primary bg-cover bg-center"
          style={{
            backgroundImage: "url(/brand/art/pine59-auth-graphic.png)",
          }}
        >
          <img
            src="/brand/logo-full-dark.svg"
            alt="Pine59"
            className="h-12 w-auto max-w-[60%]"
          />
        </div>
        <div className="flex flex-col items-center gap-3 p-6 text-center">
          <DialogTitle className="text-3xl font-semibold tracking-tight">
            Introducing Pine59
          </DialogTitle>
          <p className="text-lg font-medium">
            Same products. Same team. New company.
          </p>
          <DialogDescription className="text-balance">
            Pine59 is the new home for Unacast&apos;s Aggregated Location
            Insights business. Your access, data and existing workflows remain
            the same.
          </DialogDescription>
          <a
            href="https://pine59.com/about"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex h-10 w-full items-center justify-center gap-1 rounded-md bg-muted text-sm font-medium text-primary hover:underline"
          >
            Learn more about Pine59
            <ArrowUpRight className="h-4 w-4" />
          </a>
          <Button className="w-full" onClick={dismiss}>
            Continue to Console
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
